<template>
  <iframe id="iframe" :src="url" frameborder="0"></iframe>
</template>

<script>
import IframeMessenger from '../../utils/iframePostMessage'
import withRouteTracking from '../../utils/withRouteTracking'

const Profile = {
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  data() {
    return {
      url: process.env.fcswUrl,
      domain: process.env.fcswDomain,
      IframeElement: '',
      IframeMessage: null
    }
  },
  async mounted() {
    this.IframeElement = document.getElementById('iframe')
    this.IframeMessage = new IframeMessenger({
      domain: this.domain,
      iframeElement: this.IframeElement,
      routeQuery: this.$route.query,
    })
    this.IframeMessage.init()
    // 监听消息
    this.IframeMessage.registerOnMessage(({action, data}, send) => {
    })
    // 等待iframe加载完成, 发送消息
    this.IframeElement.addEventListener('load', async () => {
    })
  },
  beforeDestroy() {
    this.IframeMessage.removeListener()
  },
}

export default withRouteTracking(Profile)
</script>

<style scoped lang="less">
iframe {
  width: 100%;
  height: 100%;
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/views/technology/technologyFCSW.vue